// The name and lifetime of the cookie a blog comments page sets after a
// comment is accepted.
//
// They live here rather than beside the server code that writes the cookie for
// the reason `$lib/session-cookies` states: this module is safe to bundle into
// the browser and the writing side is not. The consent layer's cookie table
// prints both values, and its test holds the table to what a browser is given.
//
// Browser-safe: no import of any kind.

/** Tells a comments page, once, that the visitor's comment was just accepted. */
export const COMMENT_SENT_COOKIE = "blog_comment_sent";

// Two minutes: long enough to survive the redirect back to the page, short
// enough that a later visit never sees a stale thanks.
export const COMMENT_SENT_MAX_AGE_SECONDS = 120;
